import { ReactFramework } from "@/utils/templateProjects";

export const sanitizeComponentName = (name: string) => {
  // remove all non-alphanumeric characters, then split on spaces and capitalize each word for pascal case
  const processedName = name
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/^[0-9]+/, "")
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");

  return processedName;
};

export const createDummyComponent = (
  staticContents: string,
  framework: ReactFramework,
  componentName?: string
): string => {
  const sanitizedComponentName = sanitizeComponentName(
    componentName || "DummyComponent"
  );

  if (framework === ReactFramework.EXPO) {
    return `import React from "react";
import { View } from "react-native";

const ${sanitizedComponentName} = () => {
  return ${staticContents};
};

export default ${sanitizedComponentName};`;
  }

  if (framework === ReactFramework.NEXT_JS_APP_ROUTER) {
    return `"use client";
    
import React from "react";

const ${sanitizedComponentName} = () => {
  return ${staticContents};
};
  
export default ${sanitizedComponentName};`;
  }

  return `import React from "react";

const ${sanitizedComponentName} = () => {
  return ${staticContents};
};
  
export default ${sanitizedComponentName};`;
};

export const wrapWithBlankStoryboard = (
  staticContents: string,
  framework: ReactFramework
): string => {
  if (framework === ReactFramework.EXPO) {
    return `<View className="w-screen h-screen bg-white">${staticContents}</View>`;
  }

  return `<div className="w-screen h-screen bg-white">${staticContents}</div>`;
};

export const wrapWithBlankStoryboardNoTailwind = (
  staticContents: string,
  framework: ReactFramework
): string => {
  if (framework === ReactFramework.EXPO) {
    return `<View style="width: 100vw;height: 100vh;background-color: #fff;">${staticContents}</View>`;
  }

  return `<div style="width: 100vw;height: 100vh;background-color: #fff;">${staticContents}</div>`;
};
